<template>
    <div v-if="typeUser == 'admin'">
        <header class="page-header" style="display: flex; justify-content: space-between; align-items: center">
            <div>
                <h2>Dashboard</h2>
            </div>
        </header>
        <div class="card mb-0">
            <div v-if="activePromotion && activePromotion.show" class="dashboard-promotion-banner" :style="{
                background: `linear-gradient(135deg, ${activePromotion.background_from}, ${activePromotion.background_to})`
            }">
                <div class="dashboard-promotion-content">
                    <div class="dashboard-promotion-icon" v-if="activePromotion.icon">
                        {{ activePromotion.icon }}
                    </div>

                    <div>
                        <h3>{{ activePromotion.title }}</h3>
                        <p>{{ activePromotion.message }}</p>
                    </div>

                    <div v-if="activePromotion.promo_price && parseFloat(activePromotion.promo_price) > 0"
                        class="dashboard-promotion-price">
                        <span v-if="activePromotion.plan_name">
                            Plan {{ activePromotion.plan_name }}
                        </span>

                        <strong>
                            S/ {{ activePromotion.promo_price }}
                        </strong>

                        <small>
                            Antes S/ {{ activePromotion.regular_price }}
                            · {{ activePromotion.discount_percentage }}% dscto
                            · Ahorras S/ {{ activePromotion.discount_amount }}
                        </small>
                    </div>
                </div>

                <a v-if="activePromotion.button_url" :href="activePromotion.button_url" target="_blank"
                    rel="noopener noreferrer" class="dashboard-promotion-button" :style="{
                        backgroundColor: activePromotion.button_color,
                        color: activePromotion.button_text_color
                    }">
                    {{ activePromotion.button_text || 'Ver promocion' }}
                </a>
            </div>
            <RowTop :company="company" :utilities="utilities" :userHello="userHello" :configuration="configuration"
                :plan="plan" :namePackage="namePackage" :limitPackage="limitPackage" :monthLetras="monthLetras"
                :documentsCount="documentsCount" :monthPercentage="monthPercentage" :urlApp="urlApp"></RowTop>
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <div class="col-xl-3">
                            <section class="card card-dashboard">
                                <div class="card-body pt-2 pb-0" v-if="loaders.document">
                                    <template>
                                        <loader-graph :rows="4" :columns="1" :radius="50"></loader-graph>
                                    </template>
                                </div>
                                <div class="card-body pt-2 pb-0" v-show="!loaders.document">
                                    <div class="row border-bottom pb-2 mb-2 no-gutters justify-content-left">
                                        <label class="h5 mb-2">
                                            Comprobantes
                                        </label>
                                    </div>
                                    <div class="widget-summary-col">
                                        <div class="widget-summary">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <x-graph type="doughnut" :all-data="document.graph"></x-graph>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body p-0" v-show="!loaders.document">
                                    <table class="table mb-0 table-sm" style="border-color: #ffffff;">
                                        <tbody>
                                            <tr class="text-info text-bold">
                                                <td class="font-weight-bold">Cobrado</td>
                                                <td class="text-right font-weight-bold">S/&nbsp;{{
                                                    document.totals.total_payment }}</td>
                                            </tr>
                                            <tr class="text-danger text-bold">
                                                <td class="font-weight-bold">Por cobrar</td>
                                                <td class="text-right font-weight-bold">S/&nbsp;{{
                                                    document.totals.total_to_pay }}</td>
                                            </tr>
                                            <tr class="text-bold">
                                                <td class="font-weight-bold">Total</td>
                                                <td class="text-right font-weight-bold">S/&nbsp;{{ document.totals.total
                                                }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </section>
                        </div>
                        <div class="col-xl-3">
                            <section class="card card-dashboard">
                                <div class="card-body pt-2 pb-0" v-if="loaders.sale_note">
                                    <template>
                                        <loader-graph :rows="4" :columns="1" :radius="50"></loader-graph>
                                    </template>
                                </div>
                                <div class="card-body pt-2 pb-0" v-show="!loaders.sale_note">
                                    <div class="row border-bottom pb-2 mb-2 no-gutters justify-content-left">
                                        <label class="h5 mb-2">
                                            Notas de Venta
                                        </label>
                                    </div>
                                    <div class="widget-summary">
                                        <div class="widget-summary-col" v-if="sale_note">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <x-graph type="doughnut" :all-data="sale_note.graph"></x-graph>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body p-0" v-show="!loaders.sale_note">
                                    <table class="table mb-0 table-sm">
                                        <tbody>
                                            <tr>
                                                <td class="font-weight-bold" style="color: rgb(255 166 0);">Cobrado</td>
                                                <td class="text-right font-weight-bold" style="color: rgb(255 166 0);">
                                                    S/&nbsp;{{
                                                        sale_note.totals.total_payment }}</td>
                                            </tr>
                                            <tr class="text-danger text-bold">
                                                <td class="font-weight-bold">Por cobrar</td>
                                                <td class="text-right font-weight-bold">S/&nbsp;{{
                                                    sale_note.totals.total_to_pay }}</td>
                                            </tr>
                                            <tr class="text-bold">
                                                <td class="font-weight-bold">Total</td>
                                                <td class="text-right font-weight-bold">S/&nbsp;{{
                                                    sale_note.totals.total }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </section>
                        </div>
                        <div class="col-xl-6">
                            <section class="card card-dashboard">
                                <div class="card-body pt-2 pb-0">
                                    <div class="row border-bottom pb-2 mb-3 no-gutters justify-content-left">
                                        <label class="h5 mb-2">
                                            Noticias & Anuncios
                                        </label>
                                    </div>

                                    <div v-for="item in communicationsAnnouncements" :key="`a-${item.id}`"
                                        class="mb-2 p-2 border rounded bg-light">
                                        <div class="d-flex justify-content-between align-items-center mb-1">
                                            <div class="d-flex align-items-center">
                                                <span class="badge mr-2" :class="badgeClass(item)">{{ badgeLabel(item)
                                                }}</span>
                                                <div class="font-weight-bold mb-0">{{ item.title }}</div>
                                            </div>
                                            <small class="text-muted">{{ item.created_at }}</small>
                                        </div>
                                        <span class="font-weight-normal">
                                            {{ (item.message || '').substring(0, 30) }}
                                            <template v-if="item.message && item.message.length > 30">...</template>
                                        </span>
                                        <a v-if="item.message && item.message.length > 30"
                                            :href="`/dashboard/communications/view/${item.id}`" target="_blank"
                                            rel="noopener noreferrer" class="text-info ml-1">
                                            <strong>Leer más</strong>
                                        </a>
                                    </div>

                                    <div class="row border-top mb-2 pt-2 mt-3 no-gutters justify-content-end">
                                        <a href="/dashboard/communications/announcements" target="_blank"
                                            rel="noopener noreferrer" class="btn btn-primary btn-sm text-bold">
                                            Ver todas
                                        </a>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-xl-12">
                    <div class="row">
                        <div class="col-xl-6 col-md-6">
                            <section class="card card-dashboard">
                                <div class="card-body pt-2 pb-0" v-if="loaders.general">
                                    <template>
                                        <loader-graph :rows="2" :columns="3" :radius="100"></loader-graph>
                                    </template>
                                </div>
                                <div class="card-body pt-2 pb-0" v-show="!loaders.general">
                                    <div class="row border-bottom pb-2 mb-2 no-gutters justify-content-left">
                                        <label class="h5 mb-2">
                                            Totales
                                        </label>
                                    </div>
                                    <div class="widget-summary-col" v-if="general">
                                        <div class="summary">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <x-graph-line :all-data="general.graph"></x-graph-line>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body p-0" v-show="!loaders.general">
                                    <table class="table mb-0 table-sm">
                                        <tbody>
                                            <tr class="text-info text-bold">
                                                <td class="font-weight-bold">Comprobantes</td>
                                                <td class="text-right font-weight-bold">S/&nbsp;{{
                                                    general.totals.total_documents }}</td>
                                            </tr>
                                            <tr class="text-bold">
                                                <td class="font-weight-bold" style="color: rgb(255 166 0);">Notas de
                                                    Venta
                                                </td>
                                                <td class="text-right font-weight-bold" style="color: rgb(255 166 0);">
                                                    S/&nbsp;{{
                                                        general.totals.total_sale_notes }}</td>
                                            </tr>
                                            <tr class="text-bold">
                                                <td class="font-weight-bold">Total</td>
                                                <td class="text-right font-weight-bold">S/&nbsp;{{ general.totals.total
                                                }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </section>
                        </div>
                        <div class="col-xl-6">
                            <section class="card card-dashboard">
                                <div class="card-body pt-2 pb-0">
                                    <div class="row border-bottom pb-2 mb-3 no-gutters justify-content-left">
                                        <label class="h5 mb-2">
                                            Actualizaciones
                                        </label>
                                    </div>

                                    <div v-for="item in communicationsUpdates" :key="`u-${item.id}`"
                                        class="mb-2 p-2 border rounded bg-light">
                                        <div class="d-flex justify-content-between align-items-center mb-1">
                                            <div class="d-flex align-items-center">
                                                <span class="badge mr-2" :class="badgeClass(item)">{{ badgeLabel(item)
                                                    }}</span>
                                                <div class="font-weight-bold mb-0">{{ item.title }}</div>
                                            </div>
                                            <small class="text-muted">{{ item.created_at }}</small>
                                        </div>
                                        <span class="font-weight-normal">
                                            {{ (item.message || '').substring(0, 30) }}
                                            <template v-if="item.message && item.message.length > 30">...</template>
                                        </span>
                                        <a v-if="item.message && item.message.length > 30"
                                            :href="`/dashboard/communications/view/${item.id}`" target="_blank"
                                            rel="noopener noreferrer" class="text-info ml-1">
                                            <strong>Leer más</strong>
                                        </a>
                                    </div>

                                    <div class="row border-top mb-2 pt-2 mt-3 no-gutters justify-content-end">
                                        <a href="/dashboard/communications/updates" target="_blank"
                                            rel="noopener noreferrer" class="btn btn-primary btn-sm text-bold">
                                            Ver todas
                                        </a>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-xl-12">
                    <div class="row">
                        <div class="col-xl-6 col-md-6">
                            <section class="card card-dashboard">
                                <div class="card-body pt-2 pb-0" v-if="loaders.items_by_sales">
                                    <template>
                                        <loader-graph :rows="4" :columns="1" :radius="100"
                                            :hideCircle="true"></loader-graph>
                                    </template>
                                </div>
                                <div class="card-body pt-2 pb-0" v-show="!loaders.items_by_sales">
                                    <div class="row border-bottom pb-2 mb-3 no-gutters justify-content-left">
                                        <label class="h5 mb-2">
                                            Producto mas Vendidos
                                        </label>
                                    </div>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th class="text-center tableTopProductHead">#</th>
                                                    <th class="tableTopProductHead">Nombre</th>
                                                    <th class="text-center tableTopProductHead">Mov</th>
                                                    <th class="text-center tableTopProductHead text-right">Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-for="(row, index) in items_by_sales">
                                                    <tr :key="index">
                                                        <td class="text-center tableTopProduct">{{ index + 1 }}</td>
                                                        <td class="tableTopProduct">{{ row.description }}</td>
                                                        <td class="text-center tableTopProduct">{{ row.move_quantity }}
                                                        </td>
                                                        <td class="text-center tableTopProduct">{{ row.total }}</td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="card-footer">
                                    <div class="row">
                                        <div class="col-sm text-left pl-2">
                                            <el-checkbox v-model="form.enabled_move_item"
                                                @change="loadDataAditional">Por
                                                Movimientos</el-checkbox>
                                        </div>
                                        <div class="col-sm text-right pr-2">
                                            <a class="btn btn-primary btn-sm" href="dashboard/sales-by-product">Ver
                                                todo</a>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                        <div class="col-xl-6 col-md-6">
                            <section class="card card-dashboard">
                                <div class="card-body pt-2 pb-0" v-if="loaders.top_customers">
                                    <template>
                                        <loader-graph :rows="4" :columns="1" :radius="100"
                                            :hideCircle="true"></loader-graph>
                                    </template>
                                </div>
                                <div class="card-body pt-2 pb-0" v-show="!loaders.top_customers">
                                    <div class="row border-bottom pb-2 mb-3 no-gutters justify-content-left">
                                        <label class="h5 mb-2">
                                            Top clientes
                                        </label>
                                    </div>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th class="text-center tableTopProductHead">#</th>
                                                    <th class="tableTopProductHead">Cliente</th>
                                                    <th class="text-center tableTopProductHead">Trans</th>
                                                    <th class="text-center tableTopProductHead text-right">Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-for="(row, index) in top_customers">
                                                    <tr :key="index">
                                                        <td class="text-center tableTopProduct">{{ index + 1 }}</td>
                                                        <td class="tableTopProduct">
                                                            {{ row.name }}
                                                            <br />
                                                            <small class="text-muted" v-text="row.number"></small>
                                                        </td>
                                                        <td class="text-center tableTopProduct">{{
                                                            row.transaction_quantity
                                                        }}</td>
                                                        <td class="text-center tableTopProduct">{{ row.total }}</td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="card-footer">
                                    <div class="row">
                                        <div class="col-sm text-left pl-2">
                                            <el-checkbox v-model="form.enabled_transaction_customer"
                                                @change="loadDataAditional">Ordenar por
                                                transacciones</el-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>


            <div class="row">
                <div class="col-xl-12">
                    <div class="row">
                        <div class="col-xl-12 col-md-12 col-lg-12">
                            <dashboard-stock></dashboard-stock>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.widget-summary .summary {
    min-height: inherit;
}

.custom-badge {
    font-size: 15px;
    font-weight: bold;
}

.card.card-dashboard .table td,
.card.card-dashboard .table th {
    font-size: 0.9rem;
    font-weight: 500;
}

.dashboard-promotion-banner {
    margin: 0 1rem 1rem 1rem;
    padding: 1.4rem 1.8rem;
    border-radius: 14px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.16);
}

.dashboard-promotion-content {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.dashboard-promotion-icon {
    font-size: 2rem;
    line-height: 1;
}

.dashboard-promotion-banner h3 {
    margin: 0 0 0.35rem 0;
    color: #fff;
    font-size: 1.45rem;
    font-weight: 800;
    text-transform: uppercase;
}

.dashboard-promotion-banner p {
    margin: 0;
    color: #fff;
    font-size: 1rem;
}

.dashboard-promotion-button {
    border-radius: 999px;
    padding: 0.7rem 1.5rem;
    font-weight: 700;
    text-decoration: none;
    white-space: nowrap;
}

.dashboard-promotion-button:hover {
    text-decoration: none;
    opacity: 0.92;
}

@media (max-width: 768px) {
    .dashboard-promotion-banner {
        flex-direction: column;
        align-items: flex-start;
        margin: 0 0.75rem 1rem 0.75rem;
    }
}

.dashboard-promotion-price {
    margin-top: 0.65rem;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.65rem;
}

.dashboard-promotion-price span {
    color: #fff;
    font-weight: 700;
    opacity: 0.95;
}

.dashboard-promotion-price strong {
    background: rgba(255, 255, 255, 0.18);
    color: #fff;
    border-radius: 999px;
    padding: 0.35rem 0.8rem;
    font-size: 1.15rem;
    font-weight: 800;
}

.dashboard-promotion-price small {
    color: #fff;
    opacity: 0.9;
    font-weight: 600;
}
</style>
<script>
import DashboardStock from "./partials/dashboard_stock.vue";
import queryString from "query-string";
import LoaderGraph from "../components/loaders/l-graph.vue";
import RowTop from "./RowTop";
import DashboardInventory from "./partials/dashboard_inventory.vue";
import { mapActions, mapState } from "vuex/dist/vuex.mjs";

export default {
    props: ["typeUser", "soapCompany", 'configuration', "userHello", "plan", "namePackage", "limitPackage", "monthLetras", "documentsCount", "monthPercentage", "urlApp"],
    components: { DashboardStock, LoaderGraph, RowTop, DashboardInventory },
    data() {
        return {
            loading_search: false,
            records_base: [],
            selected_customer: null,
            customers: [],
            resource: "dashboard",
            establishments: [],
            balance: {
                totals: {},
                graph: {},
            },
            document: {
                totals: {},
                graph: {},
            },
            sale_note: {
                totals: {},
                graph: {},
            },
            general: {
                totals: {},
                graph: {},
            },
            purchase: {
                totals: {},
                graph: {},
            },
            utilities: {
                totals: {},
                graph: {},
            },
            form: {},
            pickerOptionsDates: {
                disabledDate: (time) => {
                    time = moment(time).format("YYYY-MM-DD");
                    return this.form.date_start > time;
                },
            },
            pickerOptionsMonths: {
                disabledDate: (time) => {
                    time = moment(time).format("YYYY-MM");
                    return this.form.month_start > time;
                },
            },
            records: [],
            items_by_sales: [],
            top_customers: [],
            recordId: null,
            showDialogDocumentPayments: false,
            showDialogSaleNotePayments: false,
            filter_item: false,
            all_items: [],
            items: [],
            company: {},
            loaders: {},
            communicationsAnnouncements: [],
            communicationsUpdates: [],
            activePromotion: {
                show: false,
            },
        };
    },
    async created() {
        this.loadConfiguration()
        this.$store.commit('setConfiguration', this.configuration)
        this.initForm();
        this.initLoaders();
        await this.$http.get(`/${this.resource}/filter`).then((response) => {
            this.establishments = response.data.establishments;
            this.form.establishment_id =
                this.establishments.length > 0 ? this.establishments[0].id : null;
        });
        await this.loadAll();
        await this.loadCommunications();
        await this.filterItems();
    },

    methods: {
        ...mapActions([
            'loadConfiguration',
        ]),
        changeFilterItem() {
            this.form.item_id = null;
            this.loadDataUtilities();
        },
        searchRemoteItems(input) {
            if (input.length > 1) {
                this.loading_search = true;
                let parameters = `input=${input}`;
                this.$http
                    .get(`/reports/data-table/items/?${parameters}`)
                    .then((response) => {
                        this.items = response.data.items;
                        this.loading_search = false;

                        if (this.items.length == 0) {
                            this.filterItems();
                        }
                    });
            } else {
                this.filterItems();
            }
        },
        filterItems() {
            this.items = this.all_items;
        },
        calculateTotalCurrency(currency_type_id, exchange_rate_sale, total) {
            if (currency_type_id == "USD") {
                return parseFloat(total) * exchange_rate_sale;
            } else {
                return parseFloat(total);
            }
        },
        clickDownloadDispatch(download) {
            window.open(download, "_blank");
        },
        clickDownload(type) {
            let query = queryString.stringify({
                ...this.form,
            });
            window.open(`/reports/no_paid/${type}/?${query}`, "_blank");
        },
        initForm() {
            this.form = {
                item_id: null,
                establishment_id: null,
                enabled_expense: null,
                enabled_move_item: false,
                enabled_transaction_customer: false,
                period: "last_week",
                date_start: moment().subtract(7, 'days').format("YYYY-MM-DD"),
                date_end: moment().format("YYYY-MM-DD"),
                month_start: moment().format("YYYY-MM"),
                month_end: moment().format("YYYY-MM"),
                customer_id: null,
            };
        },
        changeDisabledDates() {
            if (this.form.date_end < this.form.date_start) {
                this.form.date_end = this.form.date_start;
            }
            this.loadAll();
        },
        changeDisabledMonths() {
            if (this.form.month_end < this.form.month_start) {
                this.form.month_end = this.form.month_start;
            }
            this.loadAll();
        },
        changePeriod() {
            if (this.form.period === "month") {
                this.form.month_start = moment().format("YYYY-MM");
                this.form.month_end = moment().format("YYYY-MM");
            }
            if (this.form.period === "between_months") {
                this.form.month_start = moment().startOf("year").format("YYYY-MM"); //'2019-01';
                this.form.month_end = moment().endOf("year").format("YYYY-MM");
            }
            if (this.form.period === "date") {
                this.form.date_start = moment().format("YYYY-MM-DD");
                this.form.date_end = moment().format("YYYY-MM-DD");
            }
            if (this.form.period === "between_dates") {
                this.form.date_start = moment().startOf("month").format("YYYY-MM-DD");
                this.form.date_end = moment().endOf("month").format("YYYY-MM-DD");
            }
            this.loadAll();
        },
        loadAll() {
            this.loadData();
            // this.loadUnpaid();
            this.loadDataAditional();
            this.loadDataUtilities();
            //this.loadCustomer();
            this.loadCompany();
            this.changeStock();
        },
        changeStock() {
            this.$eventHub.$emit("changeStock", this.form.establishment_id);
        },
        loadCompany() {
            this.$http.get(`/companies/record`).then((response) => {
                this.company = response.data.data;
            });
        },
        initLoaders() {
            this.loaders = {
                document: true,
                sale_note: true,
                general: true,
                balance: true,
                utility: true,
                purchase: true,
                items_by_sales: true,
                top_customers: true,
            };
        },
        showLoadersLoadData() {
            this.loaders.document = true;
            this.loaders.sale_note = true;
            this.loaders.general = true;
            this.loaders.balance = true;
        },
        hideLoadersLoadData() {
            this.loaders.document = false;
            this.loaders.sale_note = false;
            this.loaders.general = false;
            this.loaders.balance = false;
        },
        loadData() {
            this.showLoadersLoadData();

            this.$http.post(`/${this.resource}/data`, this.form).then((response) => {
                this.document = response.data.data.document;
                // this.documents_quantity = response.data.data.quantity;
                this.balance = response.data.data.balance;
                this.sale_note = response.data.data.sale_note;
                this.general = response.data.data.general;
                this.customers = response.data.data.customers;
                this.items = response.data.data.items;
                this.hideLoadersLoadData();
            });
        },
        loadDataAditional() {
            this.showLoadersLoadDataAditional();

            this.$http
                .post(`/${this.resource}/data_aditional`, this.form)
                .then((response) => {
                    this.purchase = response.data.data.purchase;
                    this.items_by_sales = response.data.data.items_by_sales;
                    this.top_customers = response.data.data.top_customers;
                    this.hideLoadersLoadDataAditional();
                });
        },
        loadDataUtilities() {
            this.loaders.utility = true;

            this.$http
                .post(`/${this.resource}/utilities`, this.form)
                .then((response) => {
                    this.utilities = response.data.data.utilities;
                    this.loaders.utility = false;
                });
        },
        showLoadersLoadDataAditional() {
            this.loaders.purchase = true;
            this.loaders.items_by_sales = true;
            this.loaders.top_customers = true;
        },
        hideLoadersLoadDataAditional() {
            this.loaders.purchase = false;
            this.loaders.items_by_sales = false;
            this.loaders.top_customers = false;
        },
        loadCommunications() {
            this.$http.get('/dashboard/communications').then((response) => {
                if (response.data.success) {
                    const data = response.data.data || {}
                    this.communicationsAnnouncements = data.announcements || []
                    this.communicationsUpdates = data.updates || []
                    this.activePromotion = data.promotion || { show: false }
                }
            })
        },
        badgeLabel(item) {
            if (item.event_type === 'announcement') return 'Importante'
            if (item.priority === 'critical') return 'Urgente'
            if (item.priority === 'warning') return 'Advertencia'
            return 'Info'
        },
        badgeClass(item) {
            if (item.event_type === 'announcement') return 'badge-warning'
            if (item.priority === 'critical') return 'badge-danger'
            if (item.priority === 'warning') return 'badge-warning'
            return 'badge-info'
        },
        truncateText(text, max = 110) {
            if (!text) return '';
            return text.length > max ? text.substring(0, max) + '...' : text;
        },
    },
};
</script>



// WEBPACK FOOTER //
// modules/Dashboard/Resources/assets/js/views/index.vue